module.exports = "/fonts/fa-regular-400.woff?7aaf5675efd6339e9aba53ecbe5f1e36";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/fontawesome/webfonts/fa-regular-400.woff
// module id = 0fjz
// module chunks = 0 1